export const lightTheme = {
  colors: {
    accent: {
      main: '#4543A6',
      secondary: '#fff',
      hover: '#E1E1F3'
    },
    background: {
      // Colours that must follow dark mode are CSS values; in light mode they resolve to the old hexes.
      default: 'light-dark(#F6F5F8, var(--mantine-color-dark-8))',
      layout: '',
      dark: '',
      action: '#6A69C6'
    },
    common: {
      white: 'var(--mantine-color-body)',
      black: 'var(--mantine-color-text)',
      blue: '#228be6',
      grey: '#868e96',
      grey500: '#495057'
    },
    text: {
      main: '#4543A6',
      hover: '',
      secondary: 'light-dark(#616161, var(--mantine-color-dark-1))',
      dark: '',
      label: ''
    },
    border: {
      default: 'light-dark(#C4C4C4, var(--mantine-color-dark-4))',
      primary: '#CDD4DF;',
      light: '',
      active: '',
      hover: '',
      variant1: ''
    },
    tab: {
      main: '#242424'
    },
    danger: {
      main: '',
      hover: ''
    },
    success: { main: '', hover: '' }
  },
  fonts: {
    main: {
      fontFamily: 'Roboto'
    },
    title: {
      'font-family': 'Roboto',
      'font-size': '24px',
      'font-weight': 600,
      'line-height': '29px',
      'letter-spacing': '0em'
    },
    text: {
      'font-family': 'Roboto',
      'font-size': '16px',
      'font-weight': 500,
      'line-height': '22px',
      'letter-spacing': '0em'
    },
    label: {
      'font-family': 'Roboto',
      'font-size': '14px',
      'font-weight': 500,
      'line-height': '22px',
      'letter-spacing': '0em'
    }
  },
  shadow: {},
  borders: {
    input: '4px',
    button: '10px',
    badge: '8px'
  }
};
